import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { ServerConnectionService } from '../server-connection.service';
import { UtilitiesService } from '../utilities.service';
import { CoreModule } from '../../core.module';
import { ApplyPromoCodeResponse, PreviewPromoCodeResponse } from '../../../types/responses';

@Injectable({
	providedIn: CoreModule,
})
export class PromoCodeService {
	private _promoCodeById = new ReplaySubject(1);

	private _promoCodeByCode = new ReplaySubject(1);

	private _promoCodeStore = new ReplaySubject<Array<any>>(1);

	private _updatePromoCode = new Subject<boolean>();

	private dataStore = {
		promoCode: {
			byId: {},
			byCode: {},
			store: [],
		},
	};

	constructor(
		private scs: ServerConnectionService,
		private us: UtilitiesService,
	) {
		this._promoCodeById.next({});
	}

	get promoCodeById$() {
		return this._promoCodeById.asObservable();
	}

	get promoCodeByCode$() {
		return this._promoCodeByCode.asObservable();
	}

	get promoCodeStore() {
		return this._promoCodeStore.asObservable();
	}

	get updatePromoCode() {
		return this._updatePromoCode.asObservable();
	}

	triggerUpdatePromoCode() {
		this._updatePromoCode.next(true);
	}

	public checkCode(promoCode, siteAdvert, email, referrer, user) {
		let query;
		if (user) {
			query = `user=${user}`;
		}
		return this.scs.http$('GET', `/api/promo-codes/${promoCode}/${siteAdvert}/${email}/${referrer}`, query, null);
	}

	public getMembershipPromocode(username) {
		return this.scs.http$('GET', `/api/subscriptions/promocode/${username}`, null, null);
	}

	// TODO: Why are we fetching all promo codes? This should be removed...

	public fetchCodes() {
		this.scs.http$('GET', '/api/promo-codes/', null, null).subscribe(
			(result: any) => {
				this.finalizePromoCodes(result);
			},
		);
	}

	public previewPromostack(code: string, promoStackId: string) {
		return this.scs.post$<PreviewPromoCodeResponse>('/api/promo-codes/preview', {
			code,
			promoStackId,
		});
	}

	public apply(code: string, targetId: string, type: 'promoStack' | 'featuredBook') {
		return this.scs.post$<ApplyPromoCodeResponse>('/api/promo-codes/apply', {
			code,
			targetId,
			type,
		});
	}

	public finalizePromoCodes(result) {
		result.promoCodes.forEach(
			(code) => {
				this.dataStore.promoCode.byId[code._id] = code;
				this.dataStore.promoCode.byCode[code.code] = code;
				this.dataStore.promoCode.store.push(code);
			},
		);
		this.dataStore.promoCode.store = this.us.uniqueArray(this.dataStore.promoCode.store, '_id');
		this._promoCodeById.next(this.dataStore.promoCode.byId);
		this._promoCodeByCode.next(this.dataStore.promoCode.byCode);
		this._promoCodeStore.next(this.dataStore.promoCode.store);
	}

	public fetchCodeByReferrer(referrer) {
		return this.scs.http$('GET', `/api/promo-codes/by-referrer/${referrer}`, null, null);
	}

	/**
	 * @deprecated
	 */
	public logUse(promoCodeId, promoCodeCurrentLimit) {
		return this.scs.http$('PUT', `/api/promo-codes/log-use/${promoCodeId}`, null, promoCodeCurrentLimit);
	}
}
